import { Controller } from 'stimulus';
import { customIcon } from './map_pin_generator';

export default class extends Controller {
  connect() {
    // The Google Maps API is only loaded on pages that render
    // shared/google_maps_js (removed from the main layout in May 2026), so
    // the profile map cannot draw here. Skip quietly instead of throwing.
    const { GMaps } = window;
    if (typeof GMaps !== 'function' || typeof google === 'undefined') return;
    this.currentLocation = { ...this.defaultLocation() };
    this.map = new GMaps({
      div: '#map',
      zoom: 12,
      lat: this.currentLocation.lat,
      lng: this.currentLocation.lng,
      zoomControl: false,
      fullscreenControl: false,
      mapTypeControl: false,
    });
    this.addPin();
  }

  addPin() {
    const icon = customIcon({ multiple: true, color: '#e7ab00' });
    this.map.addMarker({ ...this.defaultLocation(), icon, label: '•' });
  }

  defaultLocation() {
    const coord = this.data
      .get('location')
      .split(',')
      .map((a) => parseFloat(a));

    return { lat: coord[0], lng: coord[1] };
  }
}
